var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-components",
    transform: "translate(-74.000000, -192.000000)",
    stroke: "#8892B0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(56.000000, 175.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-10",
    transform: "translate(18.814918, 17.242855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54720991,3.02101871 L13,3.02101871 C14.1045695,3.02101871 15,3.91644921 15,5.02101871 L15,16.0210187 C15,17.1255882 14.1045695,18.0210187 13,18.0210187 L2,18.0210187 C0.8954305,18.0210187 -3.0881846e-16,17.1255882 0,16.0210187 L0,9.14271294 L0,9.14271294",
    id: "Rectangle",
    transform: "translate(7.500000, 10.521019) rotate(-270.000000) translate(-7.500000, -10.521019) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0774791,-0.472991196 L12.5774791,12.7837229 L10.9860364,15.0401959 L9.46292476,13.0851478 L9.35735449,0.0270088038 L12.0774791,-0.472991196 Z",
    id: "Rectangle",
    transform: "translate(10.967417, 7.443150) rotate(-315.000000) translate(-10.967417, -7.443150) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b0a465d22384cdac7f4928f7192f2dc6.svg";
export { ForwardRef as ReactComponent };